import move_sound from './move.mp3'
import roll_sound from './roll.mp3'
import soundtrack_sound from './main.mp3'
import checkpoint_sound from './checkpoint.mp3'

const move = new Audio(move_sound)
const roll = new Audio(roll_sound)
const soundtrack = new Audio(soundtrack_sound)
const checkpoint = new Audio(checkpoint_sound)


export { move, roll, soundtrack, checkpoint }
